import request from '@/utils/request';
import { parseJSON } from '@/utils';

export const saveConfig = params => {
  return request.post(`//${location.host}/config/create-watermark-template`, {
    template: params.template,
    url: params.url,
    // xiangji: '2021-10-01',
  });
};

export const getConfig = params => {
  return request.get(`//${location.host}/config/get-watermark-template`).then(res => {
    return parseJSON(res.data.template.watermarkTemplate, {});
  });
};

export const doPreview = params => {
  return request.get(
    `//api.tosoiot.com/?Action=GetWatermarkPreview&template=${encodeURIComponent(JSON.stringify(params, null, 0))}`
  );
};
